var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreated = function SvgCreated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.502H9.533a1 1 0 0 1-.833-.445l-.406-.61a1.002 1.002 0 0 0-.833-.445H3.997a1 1 0 0 0-1 1v1.001a2 2 0 0 0 2 2.001h6.002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.503 21.004H15a.5.5 0 0 1-.5-.5v-.407a2.1 2.1 0 0 1 2.095-2.095h3.313a2.1 2.1 0 0 1 2.095 2.095v.406a.5.5 0 0 1-.5.5M18.253 15.502a2 2 0 1 1 .008 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.003 8.999V6.998a2 2 0 0 0-2.001-2H5.997a2 2 0 0 0-2 2v10.004"
  }))));
};
export { SvgCreated as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOGIwN2VkYjA2MzAxZjNhZDZiZjA0MzA3MWVlNDQyZWIuc3ZnIjs=";